import { Base } from "../Base";
import { Name } from "../Name";
import { system } from "../system";
import { Restriction } from "./Restriction";
export class Class extends Base {
    base;
    class = "array";
    _name;
    get name() {
        return (this._name ??= Name.fromArray(this.base));
    }
    get definition() {
        return Object.assign(super.definition, { base: this.base.definition });
    }
    constructor(base, name) {
        super();
        this.base = base;
        this._name = name;
    }
    is(value) {
        return system.Array.isArray(value) && value.every(this.base.is.bind(this.base));
    }
    flawed(value) {
        const result = super.flawed(value);
        return (result && {
            ...result,
            flaws: (Array.isArray(value)
                ? value.map(this.base.flawed.bind(this.base)).map((flaw, index) => flaw && { ...flaw, index })
                : [this.base.flawed(undefined)]).filter((f) => !!f),
        });
    }
    prune(value) {
        return this.is(value) ? value.map(this.base.prune.bind(this.base)) : undefined;
    }
    restrict(...restriction) {
        return super.restrict(...(Base.Restriction.is(restriction) ? restriction : Restriction.convert(restriction)));
    }
    static create(base, ...restriction) {
        const result = new Class(base);
        return ((value) => Array.isArray(value) && value.length == 0)(restriction)
            ? result
            : result.restrict(...restriction);
    }
}
//# sourceMappingURL=Class.js.map